module.exports = __webpack_public_path__ + "static-portal/img/news12-2.e1f4fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-2.jpg
// module id = adcd
// module chunks = 4